export interface RGBA {
  r: number;
  g: number;
  b: number;
  a: number;
}

export enum PaintMode {
  Fill = "fill",
  Brush = "brush",
  Pick = "pick",
  Erase = "erase"
}

export interface BrushProp {
  low_color: RGBA;
  medium_color: RGBA;
  high_color: RGBA;
  low_color_level: number;
  medium_color_level: number;
  high_color_level: number;
  brushRadius?: number;
  brushHardness?: number;
  [key: string]: RGBA | number | undefined;
}

export interface RenderingProp {
  [key: string]: number;
}

export interface Preset {
  id?: string;
  img?: string;
  group: string;
  brushProp: BrushProp;
  renderingProp: RenderingProp;
}

export interface BrushConfig {
  low_color: { a: number };
  medium_color: { a: number };
  high_color: { a: number };
}

export type BrushConfigKey = "wash" | "drybrush" | "paint";
export type PaintModeKey = keyof typeof PaintMode;
export type ColorType = "low_color" | "medium_color" | "high_color";

export interface FDMSlot {
  color: RGBA;
  meshes: Set<string>;
}
